import {useCallback, useMemo} from 'react'

import {ItemType} from '../../../api/memex-items/item-type'
import {CellEditorUI, DraftConvert} from '../../../api/stats/contracts'
import {usePostStats} from '../../../hooks/common/use-post-stats'
import type {ColumnModel} from '../../../models/column-model'
import type {MemexItemModel} from '../../../models/memex-item-model'
import {isValidDraftItemColumn} from '../../../state-providers/memex-items/memex-item-helpers'

function showConvertToIssueRepositoryPicker(
  {contentType}: {contentType: ItemType},
  columnId: ColumnModel['id'],
  isIssueField = false,
) {
  // Only ever show the picker for draft issues
  if (contentType !== ItemType.DraftIssue) return false
  if (isIssueField) return true

  // Only show the picker if the column is not valid for drafts
  return !isValidDraftItemColumn(columnId)
}

type UseConvertToDraftProps = {
  model: MemexItemModel
  columnId: ColumnModel['id']
  isIssueField?: boolean
}

export function useConvertToIssueHelper({model, columnId, isIssueField}: UseConvertToDraftProps) {
  const {postStats} = usePostStats()
  const showConvertToIssue = showConvertToIssueRepositoryPicker(
    {contentType: model.contentType},
    columnId,
    isIssueField,
  )
  const onRowConvertSuccess = useCallback(() => {
    postStats({
      name: DraftConvert,
      ui: CellEditorUI,
      memexProjectItemId: model.id,
    })
  }, [model.id, postStats])

  const props = useMemo(
    () => ({
      showConvertToIssue,
      onRowConvertSuccess,
    }),
    [showConvertToIssue, onRowConvertSuccess],
  )

  return props
}
